export default __webpack_public_path__ + "static/media/canmera.b61306f6.mtl";